import { render, staticRenderFns } from "./areaStaffBind.vue?vue&type=template&id=16b1b90e&scoped=true"
import script from "./areaStaffBind.vue?vue&type=script&lang=js"
export * from "./areaStaffBind.vue?vue&type=script&lang=js"
import style0 from "./areaStaffBind.vue?vue&type=style&index=0&id=16b1b90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b1b90e",
  null
  
)

export default component.exports